"use client"
import { Box } from "@quintoandar-tokko/jopijs";
import GenericErrorImage from "@/public/images/generic-error.png";
import ImageNext from "@/components/shared/ImageNext";
import CalendarButton from "../calendarButton/CalendarButton";
import useHandleInitialCalendarData from "../hooks/useHandleInitialCalendarData";
import Trans from "@/components/shared/Trans";
import translations from './genericError.trans.json'
import style from "./genericError.module.scss"


export default function GenericError() {
  const { fetchInitialData } = useHandleInitialCalendarData()

  return (
    <Box as="section" className={style.genericError}>
      <ImageNext
        className={style.genericErrorImage}
        src={GenericErrorImage}
        width="124"
        height="100"
        alt="tokkobroker"
        unoptimized
      />
      <Box as="h1" className={style.genericErrorTitle}>
        {Trans(translations, 'GenericErrorTitle')}
      </Box>
      <Box as="h2" className={style.genericErrorSubtitle}>
        {Trans(translations, 'GenericErrorSubtitle')}
      </Box>
      <CalendarButton
        className={style.genericErrorButton}
        onClick={fetchInitialData}
      >
        {Trans(translations, 'GenericErrorButton')}
      </CalendarButton>
    </Box>
  );
}
